<template>
  <ErrorModal />
  <div class="chat-history-popup">
    <DxPopup
      v-model:visible="isVisible"
      :show-title="true"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      :title="t('chat.chat_history_popup_title')"
      :show-close-button="true"
      @hiding="closePopup"
      width="94vw"
      height="96vh"
      :wrapper-attr="{ class: 'history-popup' }"
    >
      <DxSplitter orientation="horizontal" class="popup-splitter popup-content">
        <DxSplitterItem size="240px" min-size="200px" max-size="380px">
          <div class="popup-padding chats-list">
            <div
              class="chat-item-container"
              v-for="conversation in conversations"
              :key="conversation.conversationId"
            >
              <div class="chat-item">
                <div class="chat-item-date">
                  {{ formatDate(conversation.conversationStartedAt) }}
                </div>

                <div
                  class="chat-item-topic"
                  :id="`topicFullText-${conversation.conversationId}`"
                  @click="getMessageByConvoId(conversation.conversationId)"
                >
                  {{ conversation.shortTopic }}
                </div>
                <DxTooltip
                  v-if="
                    conversation.shortTopic != conversation.conversationTopic
                  "
                  :hide-on-outside-click="false"
                  :target="`#topicFullText-${conversation.conversationId}`"
                  show-event="mouseenter"
                  hide-event="mouseleave"
                  position="top"
                  :container="'body'"
                >
                  {{ conversation.conversationTopic }}
                </DxTooltip>
              </div>
            </div>
          </div>
        </DxSplitterItem>

        <DxSplitterItem>
          <div class="popup-padding chat-history-container">
            <DxChat
              :items="messages"
              :user="currentUser"
              :showAvatar="true"
              :showUserName="true"
              :showDayHeaders="true"
              :showMessageTimestamp="true"
              :dayHeaderFormat="'dd/MM/yyyy'"
              :messageTimestampFormat="'hh:mm a'"
              message-template="message"
              class="chat-content"
              empty-view-template="empty-view-template"
              ><template #message="{ data }">
                <div
                  class="chat-message-text"
                  v-html="renderMessage(data.message)"
                ></div>
              </template>
              <template #empty-view-template="{}">
                <div>{{ t("chat.chat_empty") }}</div>
              </template>
            </DxChat>

            <div class="continue-btn-container row justify-end">
              <DxButton
                :text="t('chat.continue_conversation')"
                class="orange-btn-filled continue-chat-btn"
                @click="continueConversation"
              />
            </div>
          </div>
        </DxSplitterItem>
      </DxSplitter>
    </DxPopup>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import store from "../../store/index";
import MarkdownIt from "markdown-it";
import moment from "moment";
import { DxPopup } from "devextreme-vue/popup";
import { DxTooltip } from "devextreme-vue/tooltip";

import DxSplitter, { DxItem as DxSplitterItem } from "devextreme-vue/splitter";
import { DxChat } from "devextreme-vue/chat";
import { DxButton } from "devextreme-vue/button";

import AiAssistantService from "../../services/aiAssistant.service";
import ErrorModal from "../../views/ErrorModal.vue";
import { reloadChatDataSource } from "../../store/modules/custom.store";

onMounted(async () => {
  await AiAssistantService.getUserConversations();
});
const md = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true,
});

const renderMessage = (message) => {
  if (!message || !message.text) return "";

  return md.render(message.text);
};

const conversations = computed({
  get: () => store.state.chat.chatHistoryMessages,
});

const isVisible = computed({
  get: () => store.state.chat.isHistoryPopupVisible,
});

const closePopup = () => {
  store.commit("chat/updateIsHistoryPopupVisible", false);
  store.commit("chat/updateShowChat", true);
};

const currentUser = computed({
  get: () => store.state.chat.currentUser,
});

const messages = computed(
  () => store.state.chat.messagesFromSelectedConversation,
);

const getMessageByConvoId = async (id) => {
  await AiAssistantService.getMessagesByConversation(id);
  store.commit("chat/setCurrentConversationIdForHistory", id);
};

const formatDate = (date) => {
  return moment(date).format("DD-MM-YYYY");
};

const continueConversation = async () => {
  store.commit("chat/continueChatFromHistory", messages.value);
  await reloadChatDataSource();
  closePopup();
};
</script>

<style scoped lang="scss">
@use "src/content/sass/base/defaultsettings" as *;
.popup-content {
  display: flex;
  .chats-list {
    display: flex;
    flex-direction: column;
    .chat-item-container:nth-child(odd) {
      background-color: #ffffff;
    }

    .chat-item-container:nth-child(even) {
      background-color: #f7f7f7;
    }
    .chat-item-container {
      padding: 12px;
      border-bottom: 1px solid #d6d4d4;

      .chat-item-topic {
        &:hover {
          cursor: pointer;
        }
        padding-top: 2px;
        font-size: 13px;
        text-decoration: underline;
        // color: $vind-dark;
      }
    }
  }

  .chat-details {
    width: 62%;
  }
}

.popup-padding {
  padding: 0px;
}
</style>
